import { useTranslation } from 'react-i18next'
import { Input } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle'
import { useState } from 'react'
import { isValidHTML } from 'helpers/multimediaContent.helper'
import { Info, Title, Error } from './styled'

interface IProps {
  value: string
  onChange: (value: string) => void
}

const Code = ({ value, onChange }: IProps) => {
  const { t } = useTranslation()
  const [isValid, setIsValid] = useState(true)
  const translationPrefix =
    'administration.blocks.type.questionBankV2.sections.manageQuestion.multimediaContent.types.code'

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value
    onChange(newValue)
    setIsValid(isValidHTML(newValue))
  }

  return (
    <>
      <Info>
        <FontAwesomeIcon icon={faInfoCircle} />
        {t(`${translationPrefix}.alert.info`)}
      </Info>
      <Title>{t(`${translationPrefix}.subtitle`)}</Title>
      <Input.TextArea
        value={value}
        onChange={handleChange}
        autoSize={{ minRows: 1, maxRows: 4 }}
        style={{ borderColor: isValid ? '' : '#F5222D' }}
        autoFocus
      />
      {!isValid && (
        <Error>
          <FontAwesomeIcon icon={faTimesCircle} />
          {t(`${translationPrefix}.alert.error`)}
        </Error>
      )}
    </>
  )
}

export default Code
